<template>
  <m-card2 :image="category.image" :alt="category.name">
    <h5 class="my-3">{{ category.name }}</h5>
    <div class="text-left">
      <m-a class="text-decoration-none" :href="{name:'Products',query:{category:category.slug,category_column: 'slug'}}">
        <p class="d-inline-block" v-t="`category.card.more`"></p>
        <i class="bi bi-arrow-left d-inline-block mr-2"></i>
      </m-a>
    </div>
  </m-card2>
</template>

<script>
import mA from '../../Tags/A'
import mCard2 from '../../Cards/Card2'

export default {
  name: "CategoryCard",
  components: {mA, mCard2},
  props: {
    category: {}
  }
}
</script>

<style scoped>

</style>